import {updateMessageGrowl} from '@Components/message-growl/message-growl-reducer';
import {v4 as uuidv4} from 'uuid';
import {GROWL_TYPE} from '@Components/message-growl/message-growl.types';

window.PMW.mergePMW(window.PMW, {
  showMessageGrowl: (text: string) => {
    window.PMW.redux.store.dispatch(
      updateMessageGrowl({
        key: uuidv4(),
        type: GROWL_TYPE.PREMIUM,
        text,
      })
    );
  },
});
